<template>
	<div class="educa_manage_wrap" v-loading="loading">
		<div class="educa_manage_header">
			<h2>学生管理</h2>
			<div class="operation">
				<el-select v-model="tableIpt.structId" @change="changeStructId" placeholder="请选择一级组织" clearable>
					<el-option
						v-for="item in organizeList"
						:key="item.structId"
						:label="item.structName"
						:value="item.structId">
					</el-option>
				</el-select>
				<el-select v-model="teachingClassId" @change="teachingClassChange" placeholder="请选择行政班" clearable>
					<el-option
					v-for="(item,key) in teachingClassList"
					:key="key"
					:label="item.className"
					:value="item.id">
					</el-option>
				</el-select>
				<n-search-input v-model="tableIpt.mobile" :placeholder="'请输入账号/姓名/学号/手机号'" @searchInput="searchList()" style="margin-right:10px"></n-search-input>
				<el-button plain @click="addStudent()" v-if="$_has('zledu.jiaoxue.student.save')">添加学生</el-button>
				<el-button plain @click="uploadStudent()" v-if="$_has('zledu.jiaoxue.student.import')">导 入</el-button>
				<el-button plain @click="exportStudent()" :disabled="isCanExport" v-if="$_has('zledu.jiaoxue.student.export')">导 出</el-button>
				<el-button plain @click="deleteStudent()" v-if="$_has('zledu.jiaoxue.student.delete')">批量删除</el-button>
			</div>
		</div>
		<div class="educa_manage_table" :style="'padding-bottom:'+(tableData.length?'0':'16')+'px'">
      <n-table
        ref="student_manage"
        :tableData="tableData"
        :tableHeader="StudentTableHeader"
        :ISChangeCheckout="true"
        :TableHeight="TableHeight"
        @operation="operation"
      ></n-table>
			<el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageTotal.currentPage"
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageTotal.pageSize"
        :pager-count="5"
        layout="sizes, prev, pager, next"
        :total="pageTotal.total"
        class="paginator"
        v-if="tableData.length"
      ></el-pagination>
		</div>
		<!-- 添加&编辑学生弹出 -->
		<el-dialog :title="dialogTitle" :visible.sync="addStudentDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="600px" :before-close="handleClose" :show-close="false">
			<div class="training-site">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
					<el-form-item label="姓名" prop="name" class="whole_line">
						<el-input v-model="ruleForm.name" maxlength="20" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="学号" prop="studentNumber" class="whole_line">
						<el-input v-model="ruleForm.studentNumber" maxlength="20" placeholder="请输入学号" :disabled="this.ruleForm.userId&&this.ruleForm.userId!='' ? true : false"></el-input>
					</el-form-item>
					<div class="form_cont">
						<el-form-item label="证件类型" prop="cardType">
							<el-select v-model="ruleForm.cardType" placeholder="请选择证件类型">
								<el-option label="身份证" value="0"></el-option>
								<el-option label="其他" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="证件号" prop="idCard" v-if="ruleForm.cardType == 0">
							<el-input v-model="ruleForm.idCard" maxlength="18" placeholder="请输入证件号"></el-input>
						</el-form-item>
						<el-form-item label="证件号" prop="other" v-if="ruleForm.cardType == 1">
							<el-input v-model="ruleForm.other" maxlength="30" placeholder="请输入证件号"></el-input>
						</el-form-item>
						<el-form-item label="性别" prop="sex">
							<el-select v-model="ruleForm.sex" placeholder="请选择性别">
								<el-option label="男" value="0"></el-option>
								<el-option label="女" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="省份" prop="province">
							<el-select v-model="ruleForm.province" placeholder="请选择省份">
								<el-option v-for="(item,index) in provinceList" :label="item.cityName" :value="item.cityName" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="一级组织" prop="firstStructId">
							<el-select v-model="ruleForm.firstStructId" placeholder="请选择" @change="changeFirstStructId">
								<el-option v-for="(item,index) in organizeList" :label="item.structName" :value="item.structId" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="城市" prop="city">
							<el-input v-model="ruleForm.city" maxlength="20" placeholder="请输入城市"></el-input>
						</el-form-item>
						<el-form-item label="二级组织" prop="secondStructId">
							<el-select v-model="ruleForm.secondStructId" placeholder="请选择" @change="changeSecondStructId" clearable>
								<el-option v-for="(item,index) in secondOrganizeList" :label="item.structName" :value="item.structId" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="教育层次" prop="educationalLevel">
							<el-select v-model="ruleForm.educationalLevel" placeholder="请选择教育层次">
								<el-option label="高职" value="高职"></el-option>
								<el-option label="中职" value="中职"></el-option>
								<el-option label="本科" value="本科"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="班级" prop="teachingClassId">
							<el-select v-model="ruleForm.teachingClassId" placeholder="请选择" @change="changeClass">
								<el-option v-for="(item,index) in teacherClassList" :label="item.className" :value="item.id" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="入学年份" prop="schoolDate">
							<el-date-picker v-model="ruleForm.schoolDate" value-format="yyyy" type="year" placeholder="请选择入学年份"></el-date-picker>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')">保 存</el-button>
    	</span>
		</el-dialog>
		<!-- 导入学生弹出 -->
		<el-dialog title="导入学生名单" :visible.sync="centerDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="600px" :before-close="handleCloseUpload" :show-close="false">
			<p class="failMsg" v-if="fail*1 > 0">导入成功{{success}}条，失败{{fail}}条
				<a target="view_frame" @click="jumpFail()">下载查看错误模板信息</a>
			</p>
			<div class="training-site upload-content" v-loading="uploading" element-loading-text="学生名单导入中">
				<div class="left">
					<el-input readonly v-model="fileName"></el-input>
					<span class="on" v-if="fileName" @click="delFile()">删除</span>
					<span class="off" v-else>删除</span>
					<p><i>*</i>注意：</p>
					<p>1.请使用模板文件导入
						<a target="view_frame" @click="jump()">下载模板</a>
					</p>
          <p>2.请先在组织管理中创建班级后再导入学生！</p>
				</div>
				<div class="right">
					<el-upload ref="upload" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :before-upload="beforeUpload" :show-file-list=false :limit="1" :on-exceed="handleExceed" :file-list="fileList">
						<img src="/static/images/wenjianjia.png" alt="">
						<p>选择文件</p>
					</el-upload>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
        <el-button @click="handleTrainingeSites(false)" :loading="uploading">取 消</el-button>
        <el-button type="primary" @click="handleTrainingeSites(true)" :loading="uploading">保 存</el-button>
      </span>
		</el-dialog>
	</div>
</template>
<script>
  import axios from 'axios';
  import * as api from '@/api/educationalApi'
	import { StudentTableHeader } from "../../../global/table_header_data";
  import {desensitization} from "@/utils/utils";
	export default {
		data() {
			var checkIdCard = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请输入证件号'));
					return
				}
				if(value.length < 18) {
					callback(new Error('身份证号必须满足18位'));
				} else {
					callback();
				}
			};
			var checkUserName = (rule, value, callback) => {
				if (value) {
					const reg = /^[a-zA-Z0-9_-]{1,20}$/;
					if (reg.test(value)) {
						callback();
					} else {
						return callback(new Error('学号由数字、字母、下划线组成，并且不超过20位'));
					}
				}else if(value==''){
					return callback(new Error('请输入学号'));
				}else{
					callback();
				}
			};
			return {
				windowHeight: window.innerHeight, // 表格高度根据窗口高度来决定
				tableIpt: {
					name: '',
					studentNumber: '',
					mobile: '',
					structId: "",
				},
				teachingClassList:[],
				teachingClass: '',
				teachingClassId: '',
				loading: true,
				StudentTableHeader: StudentTableHeader,
      	TableHeight: "0px",
				tableData: [],
				pageTotal: {
					currentPage: 1,
					pageSize: 10,
					total: 0,
				},
				multipleSelection: [],
				empty: '暂无数据',
				deptId: sessionStorage.getItem('deptId'),
				organizeList: [],//一级组织
				secondOrganizeList: [],//二级组织
				teacherClassList: [],//新班级列表
      	dialogTitle: '添加学生',
				addStudentDialogVisible: false,//添加学生
				ruleForm: {
					userId: '',
					name: '',
					studentNumber: '',
          cardType: '',
					idCard: '',
					other: '',
					sex: '',
					province: '',
					city: '',
					firstStructId: "",
					secondStructId: "",
					educationalLevel: '',
					teachingClass: '',
					teachingClassId: '',
					schoolDate: '',
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					studentNumber: [{
						required: true,
						validator: checkUserName,
						trigger: 'blur'
					}],
					cardType: [{
						required: true,
						message: '请选择证件类型',
						trigger: 'change'
					}],
					other: [{
						required: true,
						message: '请输入证件号',
						trigger: 'blur'
					}],
					idCard: [{
						required: true,
						validator: checkIdCard,
						trigger: 'blur'
					}],
					firstStructId: [{
						required: true,
						message: '请选择一级组织',
						trigger: 'change'
					}],
					teachingClassId: [{
						required: true,
						message: '请选择班级',
						trigger: 'change'
					}]
				},
				centerDialogVisible: false,//导入学生
				fileList: [],
				fileName: '',
				file: '',
				uploading: false,
				success: '',
				fail: '',
				uploadUrl: '',
				provinceList: [{
						cityName: '北京'
					}, {
						cityName: '天津'
					}, {
						cityName: '河北'
					}, {
						cityName: '山西'
					}, {
						cityName: '内蒙古'
					},
					{
						cityName: '辽宁'
					}, {
						cityName: '吉林'
					}, {
						cityName: '黑龙江'
					}, {
						cityName: '上海'
					}, {
						cityName: '江苏'
					},
					{
						cityName: '浙江'
					}, {
						cityName: '安徽'
					}, {
						cityName: '福建'
					}, {
						cityName: '江西'
					}, {
						cityName: '山东'
					},
					{
						cityName: '河南'
					}, {
						cityName: '湖北'
					}, {
						cityName: '湖南'
					}, {
						cityName: '广东'
					}, {
						cityName: '广西'
					},
					{
						cityName: '海南'
					}, {
						cityName: '重庆'
					}, {
						cityName: '四川'
					}, {
						cityName: '贵州'
					}, {
						cityName: '云南'
					},
					{
						cityName: '西藏'
					}, {
						cityName: '陕西'
					}, {
						cityName: '甘肃'
					}, {
						cityName: '青海'
					}, {
						cityName: '宁夏'
					},
					{
						cityName: '新疆'
					}, {
						cityName: '新疆生产建设兵团'
					}
				],
				isCanExport: false,
			}
		},
		created() {
			this.init();
			let editBtn = {
				name: '编辑',
				emitName: 'edit', // 事件Type 必传
				buttonType: 'text',
			}
			let deleteBtn = {
				name: '删除',
				emitName: 'delete', // 事件Type 必传
				buttonType: 'text',
			}
			let resetBtn = {
				name: '重置密码',
				emitName: 'reset', // 事件Type 必传
				buttonType: 'text',
			}
			let buttons = []
			if(this.$_has('zledu.jiaoxue.student.update')){
				buttons.push(editBtn)
			}
			if(this.$_has('zledu.jiaoxue.student.delete')){
				buttons.push(deleteBtn)
			}
			buttons.push(resetBtn)
			this.StudentTableHeader.forEach(v=>{
				if(v.prop == 'operation'){
					v.SlotType = {
						buttons: buttons
					}
				}
			})
		},
		methods: {
			changeStructId(val){
				this.teachingClassId = ""
        this.pageTotal.currentPage = 1
				this.getTeachingClass()
			},
			init(){
				this.queryStructFirstLevel()
				this.getTeachingClass()
			},
			// 获取行政班
			getTeachingClass(){
        api.newgetTeachingClass({
					"firstStructId": this.tableIpt.structId,
					"secondStructId": "",
					"schoolId": this.deptId
				}).then(res=>{
					if(res.code == 0){
						this.teachingClassList = res.data;
					}else{
            this.$messageError(res.msg)
          }
				}).then(()=>{
					this.getStudentList();
				}).catch(error => {
					console.log(error)
				})
			},
			// 获取一级组织
			queryStructFirstLevel(){
				api.queryStructFirstLevel(this.deptId).then(rs=>{
					if(rs.code==0){
						this.organizeList = rs.data
					}else{
						this.$messageError(rs.msg)
					}
				}).then(()=>{
					this.queryTeacherClass()
				})
			},
			// 获取二级组织
			queryStructSecondLevel(val){
				api.queryStructSecondLevel(val).then(rs=>{
					if(rs.code==0){
						this.secondOrganizeList = rs.data
					}else{
						this.$messageError(rs.msg)
					}
				}).then(()=>{
					this.queryTeacherClass()
				})
			},
			// 根据组织获取班级
			queryTeacherClass(){
				this.teacherClassList = []
				api.newgetTeachingClass({
					"firstStructId": this.ruleForm.firstStructId,
					"secondStructId": this.ruleForm.secondStructId,
					"schoolId": this.deptId
				}).then(rs=>{
					if(rs.code==0){
						this.teacherClassList = rs.data
					}else{
						this.$messageError(rs.msg)
					}
				})
			},
			//切换一级组织
			changeFirstStructId(val){
				this.ruleForm.secondStructId = ""
				this.secondOrganizeList = []
				this.ruleForm.teachingClass = ""
				this.ruleForm.teachingClassId = ""
				this.teacherClassList = []
				this.queryStructSecondLevel(val)
			},
			//切换二级组织
			changeSecondStructId(){
				this.ruleForm.teachingClass = ""
				this.ruleForm.teachingClassId = ""
				this.teacherClassList = []
				this.queryTeacherClass()
			},
			//切换班级
			changeClass(val){
				this.teacherClassList.forEach(v=>{
					if(v.id == val){
						this.ruleForm.teachingClass = v.className
						this.ruleForm.firstStructId = v.firstStructId
						this.queryStructSecondLevel(v.firstStructId)
						this.ruleForm.secondStructId = v.secondStructId ? v.secondStructId : ''
					}
				})
			},
			//手机号回显
			phoneNumFilter (phone) {
				let phoneArr = [...phone];
				let str = ""
				phoneArr.map((res, index) => {
					if (index > 2 && index < 7) {
						str += '*';
					} else {
						str += res;
					}
				});
				return str;
			},
			//身份证回显
			IDCardFilter (num) {
				let numArr = [...num];
				let str = ""
				numArr.map((res, index) => {
					if (index > 3 && index < 14) {
						str += '*';
					} else {
						str += res;
					}
				});
				return str;
			},
			// 学生管理列表
			getStudentList() {
				let that = this
        api.queryNameOrMobilePage({
					name: this.tableIpt.mobile,
          page: this.pageTotal.currentPage,
          limit: this.pageTotal.pageSize,
					type: '2',
					status: '1',
					teachingClassId:this.teachingClassId,
        	structId: this.tableIpt.structId,
				}).then(res => {
					if(res.code == 0) {
						that.tableData = []
						that.TableHeight = "300px"
						let listArr = res.data;
						if(listArr.records.length>0){
            	listArr.records.forEach((v,i)=>{
								let obj = v
								let num = (listArr.current-1) * listArr.size + i+1
								let idCard = ""
								let mobile = ""
								idCard = v.idCard ? desensitization(v.idCard) : '——';
								mobile = v.mobile ? desensitization(v.mobile) : '——';
								that.$set(obj, 'idCardStr', idCard)
								that.$set(obj, 'mobileStr', mobile)
								that.$set(obj, 'num', num)
								that.tableData.push(obj)
							})
							this.pageTotal.total = listArr.total;
							// this.TableHeight = this.tableData.length * 40 + 41 + 'px';
							this.TableHeight = (that.windowHeight - 200) + 'px';
						}
						this.isCanExport = this.tableData.length === 0 ? true : false;
					} else {
						this.$messageError(res.msg);
						return
					}
					this.loading = false;
				}).catch(error => {
					console.log(error)
				})
			},
			// 添加学生
			addStudent() {
				this.rules.studentNumber[0].required = true
				this.dialogTitle = '添加学生'
				this.secondOrganizeList = []
				this.queryTeacherClass()
				this.addStudentDialogVisible = true;
			},
			// 关闭弹窗
			handleClose() {
				this.resetForm('ruleForm')
				this.ruleForm = {
					userId: '',
					name: '',
					studentNumber: '',
          cardType: '',
					idCard: '',
					other: '',
					sex: '',
					province: '',
					city: '',
					firstStructId: "",
					secondStructId: "",
					educationalLevel: '',
					teachingClass: "",
					teachingClassId: '',
					schoolDate: '',
				}
				this.addStudentDialogVisible = false;
			},
			// 重置
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			// 提交
			handleSubmit(ruleForm){
				this.$refs[ruleForm].validate((valid) => {
					if(valid) {
						if(this.ruleForm.userId && this.ruleForm.userId!=""){
							this.updateStudentFn()
						}else{
							this.addStudentFn()
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 添加
			addStudentFn(){
				let obj = {
					name: this.ruleForm.name,
					studentNumber: this.ruleForm.studentNumber,
					cardType: this.ruleForm.cardType,
					idCard: this.ruleForm.cardType==0 ? this.ruleForm.idCard : this.ruleForm.other,
					sex: this.ruleForm.sex,
					province: this.ruleForm.province,
					city: this.ruleForm.city,
					educationalLevel: this.ruleForm.educationalLevel,
					schoolDate: this.ruleForm.schoolDate,
					firstStructId: this.ruleForm.firstStructId,
					secondStructId: this.ruleForm.secondStructId,
					teachingClass: this.ruleForm.teachingClass,
					teachingClassId: this.ruleForm.teachingClassId,
				}
				api.addStudent(obj).then(res => {
					if(res.code === '0') {
						this.$messageSuccess('添加学生成功')
						this.getStudentList();
						this.handleClose();
					} else {
						this.$messageError(res.msg);
					}
				})
			},
			// 编辑
			updateStudentFn(){
				let obj = {
					userId: this.ruleForm.userId,
					name: this.ruleForm.name,
					studentNumber: this.ruleForm.studentNumber,
					cardType: this.ruleForm.cardType,
					idCard: this.ruleForm.cardType==0 ? this.ruleForm.idCard : this.ruleForm.other,
					sex: this.ruleForm.sex,
					province: this.ruleForm.province,
					city: this.ruleForm.city,
					educationalLevel: this.ruleForm.educationalLevel,
					schoolDate: this.ruleForm.schoolDate,
					firstStructId: this.ruleForm.firstStructId,
					secondStructId: this.ruleForm.secondStructId,
					teachingClass: this.ruleForm.teachingClass,
					teachingClassId: this.ruleForm.teachingClassId,
				}
				api.updateStudent(obj).then(res => {
					if(res.code === '0') {
						this.$messageSuccess('编辑学生成功')
						this.getStudentList();
						this.handleClose();
					} else {
						this.$messageError(res.msg);
					}
				})
			},
			// 编辑学生
			editRow(row) {
				this.rules.studentNumber[0].required = false
				let idCard = ""
				let other = ""
				this.secondOrganizeList = []
				if(row.cardType == 0 || row.cardType == null){
					idCard = row.idCard;
					other = '';
				}else{
					other = row.idCard;
					idCard = '';
				}
				this.ruleForm = {
					userId: row.userId,
					name: row.name,
					studentNumber: row.studentNumber,
          cardType: row.cardType?row.cardType+'':'0',
					idCard: idCard,
					other: other,
					sex: row.sex||row.sex==0 ? row.sex.toString() : "",
					province: row.province,
					city: row.city,
					firstStructId: row.firstStructId && row.firstStructId!=0 ? row.firstStructId : "",
					secondStructId: row.secondStructId && row.secondStructId!=0 ? row.secondStructId : "",
					educationalLevel: row.educationalLevel,
					teachingClass: row.teachingClass,
					teachingClassId: row.teachingClassId && row.teachingClassId!=0 ? row.teachingClassId : "",
					schoolDate: row.schoolDate,
				}
				if(row.firstStructId){
					this.queryStructSecondLevel(row.firstStructId)
				}
				this.dialogTitle = '编辑学生'
				this.addStudentDialogVisible = true
			},
			// 删除学生
			delRow(row) {
				this.$confirm('是否确认删除该条学生记录?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let obj = {
						"userIds": [row.userId],
						"userType": 2
          }
          api.deleteUser(obj).then(res => {
						if(res.code === '0') {
							this.$messageSuccess('删除成功');
							this.loading = true;
							if(this.tableData.length == 1 && this.pageTotal.currentPage > 1) {
								this.pageTotal.currentPage = this.pageTotal.currentPage - 1;
								this.getStudentList();
							} else {
								this.getStudentList();
							}
						} else {
							this.$messageError(res.msg);
						}
					}).catch(error => {
						console.log(error);
					});
				}).catch(() => {
					// this.$message({
					//     type: 'info',
					//     message: '已取消删除'
					// });
				});
			},
			// 批量删除
			deleteStudent() {
				let obj = {
					userType: 2,
					userIds: []
				}
				if(this.multipleSelection.length > 0) {
					this.multipleSelection.forEach((v, i) => {
						obj.userIds.push(v.userId)
					})
					this.$confirm("是否确认删除选中的学生记录?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					}).then(() => {
            api.deleteUser(obj).then(rs => {
							if(rs.code == 0) {
								this.$messageSuccess('删除成功')
								this.getStudentList()
							} else {
								this.$messageError(rs.msg)
							}
						}).catch(err => {
							console.log(err)
						})
					}).catch(() => {

					})
				} else {
					this.$messageWarning('请选择要删除的用户')
				}
			},
			// 重置密码
			resetRow(row) {
				this.$confirm("是否确认重置密码?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
          api.resetPassword({
            username: row.userName
          }).then((rs) => {
						if(rs.code == 0) {
							this.$messageSuccess(rs.msg)
						} else {
							this.$messageError(rs.msg)
						}
					}).then(err => {
						console.log(err)
					})
				}).catch(() => {

				});
			},
			// table-操作
			operation(type, RowData) {
				if(type=='edit'){
					this.editRow(RowData)
				}else if(type=='delete'){
					this.delRow(RowData)
				}else if(type=='reset'){
					this.resetRow(RowData)
				}else if(type=='selectChange'){
					this.multipleSelection = RowData;
				}
			},
			//=====================================================
			// 查询学生管理列表
			searchList() {
				this.loading = true;
				this.pageTotal.currentPage = 1;
				this.getStudentList();
			},
			teachingClassChange(val){
				console.log(val)
				this.pageTotal.currentPage = 1;
				this.teachingClassId = val;
				this.getStudentList();
			},
			handleCurrentChange(val) {//分页
				this.loading = true;
	      this.pageTotal.currentPage = val;
	      this.getStudentList()
	   	},
	   	handleSizeChange(val){//分页
				this.loading = true;
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getStudentList()
      },
			// 导出学生
			exportStudent() {
				let schoolId = this.deptId;
				let schoolName = sessionStorage.getItem('deptName');
				this.$confirm('确定导出全部或某个行政班的学生吗, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
          axios.get(`${process.env.BASE_API}/api-teachingaffair/teachingAffair/excel/export/${schoolId}?schoolName=${schoolName}&teachingClassId=${this.teachingClassId}`, {
            headers: {
              authorization: 'bearer '+localStorage.getItem('Authorization')
            },
            responseType: 'blob'
          }).then(rs=>{
            let url = window.URL.createObjectURL(new Blob([rs.data]), {
              // type: "application/vnd.ms-excel"
              type: 'UTF-8'
            });
            // let link = document.createElement('a');
            // link.style.display = 'none';
            // link.href = url;
            // link.setAttribute('download', `${schoolName} - 学生信息.xls`); // 自定义下载文件名（如exemple.txt）
            // document.body.appendChild(link);
            // link.click();
            this.$downloadFun(url, `${schoolName} - 学生信息.xls`)
          })
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消导出'
					});
				});
			},
			// 导入学生
			uploadStudent() {
				this.fileName = '';
				this.centerDialogVisible = true;
				this.fail = '';
				this.success = '';
				this.uploadUrl = '';
			},
			// 导入学生保存
			handleTrainingeSites(type) {
				if(type) {
					if(this.fileName) {
            this.uploading = true;
            api.importUser(this.file).then(res => {
							if(res.code == '0') {
								this.loading = true;
								this.getStudentList();
								if(res.data.fail > 0) {
									this.uploadUrl = res.data.url;
									this.success = res.data.success;
									this.fail = res.data.fail;
								} else {
									this.$messageSuccess('导入成功' + res.data.success + '条，失败' + res.data.fail + '条');
									this.centerDialogVisible = false;
								}
								this.uploading = false;
							} else {
								this.$messageError('导入的模板错误，请重新导入');
								this.uploading = false;
							}
						})
					} else {
						this.$messageError('请导入名单后再保存');
					}
				} else {
					this.$refs.upload.clearFiles();
					this.centerDialogVisible = false;
				}
			},
			handleExceed(files, fileList) {
				this.$refs.upload.clearFiles();
				// this.$messageWarning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeUpload(file) {
				this.$refs.upload.clearFiles();
				var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
				const extension2 = testmsg === 'xlsx'
				if(!extension2) {
					this.$messageWarning('上传文件只能是xlsx格式!');
				} else {
					let fd = new FormData();
					fd.append('file', file);
					fd.append('type', '2');
					fd.append('platform', '1');
					this.file = fd;
					this.fileName = file.name;
				}
				return extension2
			},
			// 删除导入文件
			delFile() {
				this.fileName = '';
				this.$refs.upload.clearFiles();
			},
			handleCloseUpload(done) {
				done();
				this.$refs.upload.clearFiles();
			},
			jump() {
				let url = process.env.BAK_NAME + '/management/excel/%E5%AF%BC%E5%85%A5%E5%AD%A6%E7%94%9F%E6%A8%A1%E6%9D%BF.xlsx';
        this.$downloadFun(url)
			},
			jumpFail() {
				// window.location.href = this.uploadUrl;
        this.$downloadFun(this.uploadUrl)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.educa_manage_wrap {
		.training-site {
			/deep/ .whole_line{
				.el-input__inner{
					width: 450px !important;
				}
			}
			.form_cont {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
			}
			/deep/ .el-input__inner {
				width: 180px;
				height: 40px;
				line-height: 40px;
			}
			/deep/ .el-form-item {
				margin-bottom: 15px;
				margin-left: 10px;
			}
			/deep/ .el-input--suffix {
				width: 180px;
			}
			/deep/ .el-form-item__error {
				top: 89%;
			}
			/deep/ .el-col-6 {
				width: 29%;
			}
		}
		.classDialog {
			/deep/ .el-dialog__body {
				padding: 30px 56px;
			}
		}
		.classCatalog {
			border: 1px solid rgba(235, 235, 235, 1);
			border-radius: 4px;
			.add-class {
				height: 42px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 14px;
				color: #5397F7;
				font-weight: 600;
				cursor: pointer;
				img {
					margin-right: 5px;
				}
			}
			/deep/ .el-input__inner {
				height: 28px;
				line-height: 28px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/studentManage/studentAdmin.vue